import React from "react"
import { PropTypes } from "prop-types"
import "./Outline.scss"
import { ROOM_TYPE } from "../../common/constants/classifications"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"
// import commaNumber from 'comma-number'

const Outline = props => {

  const { t } = props

  const roomTypeClass = (roomType) => {
    switch (roomType) {
    case ROOM_TYPE.PRIVATE_ROOM:
      return "vs-icon-private-room"
    case ROOM_TYPE.ENTIRE_HOME:
    default:
      return "vs-icon-entire-home"
    }
  }

  const roomTypeTranslation = (room_type) => {
    return room_type ? t("outline.room_type." + room_type) : null
  }

  return (
    <div>
      <span styleName="property-type">{props.property_type}</span>

      <h1 styleName="room-group-title">{props.room_title}</h1>

      <div styleName="property-title">{props.property_title}</div>

      <div styleName="address-container">
        <span className="vs-icon-pin" />
        <div styleName="address">
          <span styleName="address-text">{props.addressElement}</span>
          <a href={props.gMapUrl} target="_blank" rel="noopener" styleName="map-link">
            { t('access.googlemap') }
          </a>
        </div>
      </div>

      <ul styleName="room-spec-icon-list">
        <li className="room-spec-icon-list__roomtype">
          <span
            className={roomTypeClass(props.room_type)}
            styleName="icon"
          />
          <span>
            {roomTypeTranslation(props.room_type) ||
              props.room_type_localized}
          </span>
        </li>
        <li className="room-spec-icon-list__guests">
          <span className="vs-icon-guests" styleName="icon" />
          <span>
            <span className="notranslate">
              {props.maximum_guests > 1
                ? `1〜${props.maximum_guests}`
                : "1"}
            </span>
            {t("calendar.guest")}
          </span>
        </li>
        <li className="room-spec-icon-list__bedrooms">
          <span className="vs-icon-bedroom" styleName="icon" />
          <span>
            {t("outline.bedroom")}{" "}
            <span className="notranslate">{props.bedrooms}</span>
          </span>
        </li>
        <li className="room-spec-icon-list__bedding">
          <span className="vs-icon-bed" styleName="icon" />
          <span>
            {t("outline.bed")}{" "}
            <span className="notranslate">{props.beds}</span>
          </span>
        </li>
        <li className="room-spec-icon-list__bathrooms">
          <span className="vs-icon-bathroom" styleName="icon" />
          <span>
            {props.is_shared_bath ? t("outline.shared") : ""}
            {t("outline.bathroom")}{" "}
            <span className="notranslate">{props.bathrooms}</span>
          </span>
        </li>
        <li className="room-spec-icon-list__size">
          { props.size > 1 &&
            <React.Fragment>
              <span className="vs-icon-size" styleName="icon" />
              <span>
                <span className="notranslate">{props.size}&#x33a1;</span>
              </span>
            </React.Fragment>
          }
        </li>
      </ul>
    </div>
  )

}

Outline.propTypes = {
  room_title: PropTypes.string.isRequired,
  property_title: PropTypes.string.isRequired,
  room_type: PropTypes.string.isRequired,
  room_type_localized: PropTypes.string.isRequired,
  maximum_guests: PropTypes.number.isRequired,
  beds: PropTypes.number.isRequired,
  bedrooms: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  is_shared_bath: PropTypes.bool.isRequired,
  bathrooms: PropTypes.number.isRequired,
  review_count: PropTypes.number.isRequired
}

Outline.defaultProps = {
  room_title: "",
  property_title: "",
  maximum_guests: 0,
  beds: 0,
  bedrooms: 0,
  size: 0,
  rate: 0,
  review_count: 0
}

export default compose(withNamespaces("listings"))(Outline)
